import React, { Suspense, lazy } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import { HomeSEO } from '../components/layout/SEO';
import { usePageData } from '../contexts/DataContext';
import LoadingSpinner from '../components/common/LoadingSpinner'; // Import your spinner

// Lazy load non-critical sections
const FeaturesSection = lazy(() => import('../components/home/FeaturesSection'));
const CategoriesSection = lazy(() => import('../components/home/CategoriesSection'));
const HowToSection = lazy(() => import('../components/home/HowToSection'));
const TemplatesSection = lazy(() => import('../components/home/TemplatesSection'));
const SlipsSection = lazy(() => import('../components/home/SlipsSection'));
const TestimonialsSection = lazy(() => import('../components/home/TestimonialsSection'));
const FAQSection = lazy(() => import('../components/home/FAQSection'));

// Simple loading placeholder
const SectionLoader = () => (
  <div style={{ 
    minHeight: '200px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center' 
  }}>
    <LoadingSpinner size="medium" fullPage={false} />
  </div>
);

const HomePage = () => {
  const { data: homePage } = usePageData('homePage');


  return (
    <HelmetProvider>
      <div className="home-page">
        <HomeSEO pageData={homePage} />
        
        <HeroSection />
        
        <Suspense fallback={<SectionLoader />}>
          <FeaturesSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <CategoriesSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <HowToSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <TemplatesSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <SlipsSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <TestimonialsSection />
        </Suspense>
        
        <Suspense fallback={<SectionLoader />}>
          <FAQSection />
        </Suspense>
      </div>
    </HelmetProvider>
  );
};

export default HomePage;
